module.exports = __webpack_public_path__ + "img/card-musicians.a5f29a26.png";